import styled from '@themes/theme'

export const MoneyInfoWrap = styled.ul`
  display: flex;
  flex-flow: column;
  width: 210px;
  margin: 12px auto 0;
  .info-list {
    display: flex;
    align-items: flex-start;
    height: 52px;
    margin-bottom: 10px;
    &.heart {
      height: 62px;
    }
    &.sub-info {
      height: auto;
      padding-left: 33px;
      .info-txt {
        color: ${props=>props.theme.color.btn};
      }
      .menu-img {
        width: 16px;
        margin-top: -3px;
      }
    }
    svg {
      width: 33px;
    }
    .info-txt {
      color: ${props=>props.theme.color.mainBg};
      text-align: left;
      margin-left: 10px;
      .sub-txt {
        color: ${props=>props.theme.color.btn};
        font-weight: ${props=>props.theme.fontW.medium};
      }
    }
  }
`
